import FDictionary from '../__select';
import Form from './Form';

export default class FDictionaryTransport extends FDictionary {
  dictionary = 'transport';

  permissionAdd = [115];

  addForm() {
    const item = new Form();
    item.init()
      .then();
    return item;
  }
}
